import { useState } from "react";
import ICurrentUser from "../../entities/helper/ICurrentUser";
import { usePromiseEffect } from "../../helpers/promiseEffect";
import { cognitoUserInfo, cognitoUserToken } from "../../helpers/userHelper";
import Proveedores from "./components/Proveedores";

interface IProviderHomeProps {
  isHistorico?:boolean
}
const ProviderHome = ({isHistorico}:IProviderHomeProps) => {
  

  const [token, setToken] = useState("");
  const [currentUser, setCurrentUser] = useState<ICurrentUser>();
  const [isLoading, setIsLoading] = useState(true);
  console.log(currentUser)
  usePromiseEffect(async () => {
    const userInfo = cognitoUserToken();
    let token = await userInfo;
    setToken(token);
    let currUser = await cognitoUserInfo();
    setCurrentUser(currUser);
    setIsLoading(false);
  }, []);
  return isLoading ? (
    <div></div>
  ) : (
    <div className="row">
      <div className="col-12">
        <div className="rounded bg-white p-2 shadow">
          <div className="container-fluid mb-4">
            <h1 className="titPrincipal colorTit">Proveedores</h1>
                <Proveedores token={token} isHistorico={false}/>
            
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProviderHome;